import React from "react";
import { Button } from "../../../../controls";
import { Printer } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const handlePrintLabel = () => {
    navigate("/print_new_label");
  };

  return (
    <Button
      onClick={handlePrintLabel}
      startIcon={<Printer className="h-[20px] w-[20px]" />}
    >
      Print New Label
    </Button>
  );
};

export default Header;
